export default __webpack_public_path__ + "static/media/dll.1e3b5cf4.svg";